import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { IModulesSchoolBody } from '../../../../../core/models';
import { AdminService } from '../../../../../core/services/admin.service';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';
import { SchoolAndTrainingService } from '../../../../../core/services/school-and-training.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { environment } from '../../../../../../environments/environment';
@Component({
  selector: 'app-modules-school-admin',
  templateUrl: './modules-school-admin.component.html',
  styleUrls: ['./modules-school-admin.component.scss']
})
export class ModulesSchoolAdminComponent implements OnInit {
  //#region member and variable declaration
  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;
  todayDate: any = new Date();
  moduleName: string = "";
  modulesDescription: string = "";
  registrationDescription: string = "";
  trainingDetailsForm: FormGroup;
  moduleFormValue: FormArray;
  locationInfoForm: FormGroup;
  locationFormValue: FormArray;
  allModuleList: any;
  getLanguages: any;
  selectedLanguage: string = "";
  moduleSchoolId: string = "";
  trainingInputMethod = 'TextEditor';
  trainingUrlPath = null;
  trainingUrl = null;
  registrationInputMethod = 'TextEditor';
  registrationUrlPath = null;
  registrationUrl = null;
  //#endregion
  constructor(private adminService: AdminService,
    private formBuilder: FormBuilder,
    private appNotifyService: AppNotifyService,
    private languageService: LanguageTranslationService,
    private trainingService: SchoolAndTrainingService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.initializeFormControls();    
  }
  initializeFormControls() {
    this.trainingDetailsForm = this.formBuilder.group({
      trainingName: new FormControl(""),
      languageCode: new FormControl(""),
      trainingDescription: new FormControl(""),
      moduleFormValue: this.formBuilder.array([])
    })
    this.locationInfoForm = this.formBuilder.group({     
      locationFormValue: this.formBuilder.array([])
    })
    this.addNewModule(); //to show by default one row opened
    this.addNewLocation();
    this.languageService.getLanguages().subscribe(response => {
      this.getLanguages = response;
    })
    this.selectedLanguage = localStorage.getItem('language');
    this.lanaguageChange("");
  }
 
  //#region language dropdown change
  lanaguageChange(event) {
    const body = {
      languageCode: event ? event.languageCode : this.selectedLanguage
    }
    this.selectedLanguage = body.languageCode;
    this.modulesSchool.isLanguageCodeEmpty = false;
    this.trainingService.getModulesSchoolDetails(body).subscribe(response => {      
      this.moduleSchoolId = "";
      this.resetForm('reset');
      if (response.length > 0) {
        this.trainingDetailsForm.controls.trainingName.setValue(response[0].trainingName);       
        this.registrationDescription = response[0].registrationDescription;
        this.moduleSchoolId = response[0].moduleSchoolId;
        if (response[0].moduleSchoolLocationDetails.length > 0) {
          response[0].moduleSchoolLocationDetails.forEach((items, index) => {
            this.locationFormValue = this.locationInfoForm.get('locationFormValue') as FormArray;
            this.locationFormValue.push(this.formBuilder.group({           
              locationId: [items.locationId],
              moduleSchoolId: [items.moduleSchoolId],
              locationName: [items.locationName],
              locationDescription: [items.locationDescription],
              startDate: [new Date(items.startDate)],
              endDate: [new Date(items.endDate)],             
              totalSeats: [items.totalSeats],
              availableSeats: [items.availableSeats],
              price: [items.price],
              selectedModule: [items.selectedModule], //items.selectedModule should be in array format eg.,[{ moduleName: "1" }, { moduleName: "2" }]              
            }));
          })
        } else {
          this.addNewLocation();
        }
        if (response[0].modulesList != null) {
          if (response[0].modulesList.length > 0) {
            response[0].modulesList.forEach((items, index) => {
              this.moduleFormValue = this.trainingDetailsForm.get('moduleFormValue') as FormArray;
              this.moduleFormValue.push(this.formBuilder.group({
                moduleId: [items.moduleId],
                moduleName: [items.moduleName],
                moduleShortDescription: [items.moduleShortDescription],
                modulesDescription: [items.modulesDescription],
                startDate: [new Date(items.startDate)],
                endDate: [new Date(items.endDate)],
                price: [items.price],
                totalSeats: [items.totalSeats],
              }));
            })
          } else {
            this.addNewModule();
          }
        }        
        // this.trainingDetailsForm.controls.trainingDescription.setValue(response[0].trainingDescription);      
        this.trainingDetailsForm.get('trainingDescription').setValue(response[0].trainingDescription);
        this.transformModuleSchool(response[0]);
      } else {
        //this.appNotifyService.notify(NotifyType.INFO, 'No records available!');
        this.addNewLocation();
        this.addNewModule();
        this.trainingDetailsForm.get('trainingDescription').setValue("");
      }

    })
  }
  transformModuleSchool(moduleSchool: any) {
    if (moduleSchool) {
      if (moduleSchool.trainingUrlPath) {
        this.trainingUrlPath = moduleSchool.trainingUrlPath;
        this.trainingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.imageUrl + moduleSchool.trainingUrlPath);
        this.trainingInputMethod = "FileUpload";
      } else {
        this.trainingInputMethod = "TextEditor";
        this.trainingUrl = null;
      }
      if (moduleSchool.registrationUrlPath) {
        this.registrationUrlPath = moduleSchool.registrationUrlPath;
        this.registrationUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.imageUrl + moduleSchool.registrationUrlPath);
        this.registrationInputMethod = "FileUpload";
      } else {
        this.registrationInputMethod = "TextEditor";
        this.registrationUrl = null;
      }
    }
  }
  //#endregion
  //#region dynamic modules controls
  createModuleControls() {
    return this.formBuilder.group({
      moduleId: new FormControl(),
      moduleName: new FormControl(),
      moduleShortDescription: new FormControl(),
      modulesDescription: new FormControl(),
      startDate: new FormControl(),
      endDate: new FormControl(),
      totalSeats: new FormControl(0),
      price: new FormControl(0),
    })
  }
  addNewModule() {
    this.moduleFormValue = this.trainingDetailsForm.get('moduleFormValue') as FormArray;
    this.moduleFormValue.push(this.createModuleControls());
  }
  deleteModule(i: number) {
    //let moduleId = this.moduleFormValue.value[i].moduleId;
    let body = {
      moduleId: this.moduleFormValue.value[i].moduleId
    };
    this.adminService.deleteModuleSchoolModule(body).subscribe(response => {
      if (response) {
        this.moduleFormValue.removeAt(i);
        this.appNotifyService.notify(NotifyType.SUCCESS, 'Deleted successfully!');
      }
    })
    
  }
  //#endregion
  //#region location info panel
  createLocationControls() {
    return this.formBuilder.group({
      locationName: new FormControl(),
      locationDescription: new FormControl(),
      startDate: new FormControl(),
      endDate: new FormControl(),
      totalSeats: new FormControl(0),
      price: new FormControl(0),
      availableSeats: new FormControl(0),
      selectedModule: new FormControl(),
      locationId: new FormControl(),
      moduleSchoolId: new FormControl(),
    })
  }
  addNewLocation() {
    this.locationFormValue = this.locationInfoForm.get('locationFormValue') as FormArray;
    this.locationFormValue.push(this.createLocationControls());
  }
  deleteModuleLocation(i: number) {
    let body = {
      locationId: this.locationFormValue.value[i].locationId
    };
    this.adminService.deleteModuleSchoolLocation(body).subscribe(response => {
      if (response) {
        this.locationFormValue.removeAt(i);
        this.appNotifyService.notify(NotifyType.SUCCESS, 'Deleted successfully!');
      }
    })

  }
  //moduleList:
  
  
  //#endregion
  modulesSchool = {
    isTrainingPanelValid: false,
    //isTrainingPanelInValid: false,
    isLocationInfoPanelValid: false,
    //isLocationInfoPanelInValid: false,
    isRegistrtionPanelValid: false,
    isEmptyTrainingName: false,
    isEmptyTrainingDescription: false,
    isEmptyRegistrationDescription: false,
    isTrainingPanelContinue: false,
    isLocationInfoContinue: false,
    isSubmitted: false,
    isLanguageCodeEmpty: false,
    isEmptyTrainingUrlPath: false,
    isEmptyregistrationUrlPath: false
  }
  //#region validation operations
  protected validateTrainingForm() {
    let isValid = true;
    const controls = this.trainingDetailsForm.controls;
    if (this.modulesSchool.isTrainingPanelContinue) {
      if (controls.trainingName.value) {
        this.modulesSchool.isEmptyTrainingName = false;
      } else {
        this.modulesSchool.isEmptyTrainingName = true;
        isValid = false;
      }
      if (this.trainingInputMethod === "FileUpload") {
        if (this.trainingUrl) {
          this.modulesSchool.isEmptyTrainingUrlPath = false;
        } else {
          this.modulesSchool.isEmptyTrainingUrlPath = true;
          isValid = false;
        }
      } else {
        if (controls.trainingDescription.value) {
          this.modulesSchool.isEmptyTrainingDescription = false;
        } else {
          this.modulesSchool.isEmptyTrainingDescription = true;
          isValid = false;
        }
        this.trainingUrlPath = this.trainingUrl = null;
      }
      

      if (controls.languageCode.value) {
        this.modulesSchool.isLanguageCodeEmpty = false;
      } else {
        this.modulesSchool.isLanguageCodeEmpty = true;
        isValid = false;
      }
    }
    return isValid;
  }
  protected validateLocationInfoForm() {
    let isValid = true;
    //write condition here
    return isValid;
  }
  protected validateRegistrationForm() {
    let isValid = true;
    if (this.modulesSchool.isSubmitted) {

      if (this.registrationInputMethod === "FileUpload") {
        if (this.registrationUrlPath || this.registrationUrl) {
          this.modulesSchool.isEmptyregistrationUrlPath = false;
        } else {
          this.modulesSchool.isEmptyregistrationUrlPath = true;
          isValid = false;
        }
      } else {
        if (this.registrationDescription) {
          this.modulesSchool.isEmptyRegistrationDescription = false;
        } else {
          this.modulesSchool.isEmptyRegistrationDescription = true;
          isValid = false;
        }
        this.registrationUrlPath = null;
      }

      
    }
    return isValid;
  }
  validateModulesSchoolPage() {
    var isValid = true;
    this.modulesSchool.isTrainingPanelContinue = true;
    this.modulesSchool.isTrainingPanelValid = true;
    if (!this.validateTrainingForm()) {
      this.modulesSchool.isTrainingPanelValid = false;
      isValid = false;
    }
    this.modulesSchool.isLocationInfoContinue = true;
    this.modulesSchool.isLocationInfoPanelValid = true;
    if (!this.validateLocationInfoForm()) {
      this.modulesSchool.isLocationInfoPanelValid = false;
      isValid = false;
    }
    this.modulesSchool.isSubmitted = true;
    this.modulesSchool.isRegistrtionPanelValid = true;
    if (!this.validateRegistrationForm()) {
      this.modulesSchool.isRegistrtionPanelValid = false;
      isValid = false;
    }
    return isValid;
  }
  //#endregion
  //#region reset forms
  resetForm(type) {
    if (type == 'reset') {
      this.trainingDetailsForm.controls.trainingName.reset();
    }
    if (type == 'cancel') {
      this.selectedLanguage = "";
      this.moduleSchoolId = "";
      this.trainingDetailsForm.reset();
      this.addNewLocation();
      this.addNewModule();
    }
    this.registrationDescription = "";
    this.modulesSchool.isTrainingPanelValid = false;
    this.modulesSchool.isLocationInfoPanelValid = false;
    this.modulesSchool.isRegistrtionPanelValid = false;
    this.modulesSchool.isEmptyTrainingName = false;
    this.modulesSchool.isEmptyTrainingDescription = false;
    this.modulesSchool.isEmptyRegistrationDescription = false;
    this.modulesSchool.isTrainingPanelContinue = false;
    this.modulesSchool.isLocationInfoContinue = false;
    this.modulesSchool.isSubmitted = false;
    this.modulesSchool.isLanguageCodeEmpty = false;   
    (this.locationInfoForm.get('locationFormValue') as FormArray).clear();
    (this.trainingDetailsForm.get('moduleFormValue') as FormArray).clear();
    this.modulesSchool.isEmptyTrainingUrlPath = false;
    this.modulesSchool.isEmptyregistrationUrlPath = false;
    this.registrationUrlPath = null;
    this.registrationUrl = null;
    this.trainingUrl = null;
    this.trainingUrlPath = null;
  }
  //#endregion
  //#region save operations
  save() {
    if (!this.validateModulesSchoolPage()) { //validates all the panel 
      return;
    }
    const body: IModulesSchoolBody = {
      id: 0,
      moduleSchoolId: this.moduleSchoolId,
      trainingName: this.trainingDetailsForm.controls.trainingName.value,
      languageCode: this.trainingDetailsForm.controls.languageCode.value ? this.trainingDetailsForm.controls.languageCode.value.languageCode : localStorage.getItem('language'),
      trainingDescription: this.trainingDetailsForm.controls.trainingDescription.value,
      modulesList: this.moduleFormValue.value,
      moduleSchoolLocationDetails: this.locationFormValue.value,
      registrationDescription: this.registrationDescription,
      registrationUrlPath: this.registrationUrlPath,
      trainingUrlPath: this.trainingUrlPath
    }
    this.adminService.saveModuleSchoolDetails(body).subscribe(response => {
      this.selectedLanguage = body.languageCode;
      this.lanaguageChange("");
      //this.resetForm();
      this.appNotifyService.notify(NotifyType.SUCCESS, 'Saved successfully!');
    })
  }
  //#endregion

  
  //#region panel change
  onLocationPanelChange(event) {
    this.allModuleList = [];
    this.allModuleList = this.moduleFormValue.value;
  }
  continueToNextPanel(activeTab) {
   
    if (activeTab == 'training module') {
      this.modulesSchool.isTrainingPanelContinue = true;
      this.modulesSchool.isTrainingPanelValid = true;
      if (!this.validateTrainingForm()) {
        this.modulesSchool.isTrainingPanelValid = false;
        return
      }
      this.allModuleList = [];
      this.allModuleList = this.moduleFormValue.value; 
      this.panel.childrenItems.forEach(item => {
        if (item.expanded) {
          item.expanded = false;
          item.selected = false;
        }
      });
      this.panel.childrenItems[1].expanded = true;
      this.panel.childrenItems[1].selected = true;
    }
    else if (activeTab == 'location') {
      this.modulesSchool.isLocationInfoContinue = true;
      this.modulesSchool.isLocationInfoPanelValid = true;
      if (!this.validateLocationInfoForm()) {
        this.modulesSchool.isLocationInfoPanelValid = false;
        return;
      }
      this.panel.childrenItems.forEach(item => {
        if (item.expanded) {
          item.expanded = false;
          item.selected = false;
        }
      });
      this.panel.childrenItems[2].expanded = true;
      this.panel.childrenItems[2].selected = true;
    }
  }
  public activatePanel(index: number) {
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    if (index !== -1) {
      this.panel.childrenItems[index].expanded = true;
      this.panel.childrenItems[index].selected = true;
    }
  }
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".pdf"],
  };
  trainingSelected(event) {
    console.log(event);
  }
  trainingUploadSuccess(event) {
    console.log(event);
    this.trainingUrlPath = event.response.body.paths[0];
    if (this.trainingUrlPath) {
      const url = environment.imageUrl + `/api/${this.trainingUrlPath}`;
      this.trainingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url.replace("\\", "/"));
      this.trainingInputMethod = "FileUpload";
    } else {
      this.trainingInputMethod = "TextEditor";
    }
  }
  registrationSelected(event) {
    console.log(event);
  }
  registrationUploadSuccess(event) {
    console.log(event);
    this.registrationUrlPath = event.response.body.paths[0];
    if (this.registrationUrlPath) {
      const url = environment.imageUrl + `/api/${this.registrationUrlPath}`;
      this.registrationUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url.replace("\\", "/"));
      this.registrationInputMethod = "FileUpload";
    } else {
      this.registrationInputMethod = "TextEditor";
    }
  }
  //#endregion
}
